import { addLocaleData } from 'react-intl';
import enLocaleData from 'react-intl/locale-data/en';
import daLocaleData from 'react-intl/locale-data/da';

import enTranslationMessages from './translations/en.json';
import daTranslationMessages from './translations/da.json';
export const DEFAULT_LOCALE = 'da';

addLocaleData(enLocaleData);
addLocaleData(daLocaleData);

export const formatTranslationMessages = (locale, messages) => {
  const defaultFormattedMessages = locale !== DEFAULT_LOCALE
    ? formatTranslationMessages(DEFAULT_LOCALE, daTranslationMessages)
    : {};

  return Object.keys(messages).reduce((formattedMessages, key) => {
    const formattedMessage = !messages[key] && locale !== DEFAULT_LOCALE
      ? defaultFormattedMessages[key]
      : messages[key];

    return Object.assign(formattedMessages, { [key]: formattedMessage });
  }, {});
};

export const translationMessages = {
  en: formatTranslationMessages('en', enTranslationMessages),
  da: formatTranslationMessages('da', daTranslationMessages),
};
